import { render } from "./ApplyAvatarPosterTemplate.vue?vue&type=template&id=b9141f38&scoped=true&ts=true"
import script from "./ApplyAvatarPosterTemplate.vue?vue&type=script&lang=ts"
export * from "./ApplyAvatarPosterTemplate.vue?vue&type=script&lang=ts"

import "./ApplyAvatarPosterTemplate.vue?vue&type=style&index=0&id=b9141f38&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9141f38"]])

export default __exports__